export default 
{
  "login": "QuincyLarson",
  "id": 985197,
  "node_id": "MDQ6VXNlcjk4NTE5Nw==",
  "avatar_url": "https://avatars.githubusercontent.com/u/985197?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/QuincyLarson",
  "html_url": "https://github.com/QuincyLarson",
  "followers_url": "https://api.github.com/users/QuincyLarson/followers",
  "following_url": "https://api.github.com/users/QuincyLarson/following{/other_user}",
  "gists_url": "https://api.github.com/users/QuincyLarson/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/QuincyLarson/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/QuincyLarson/subscriptions",
  "organizations_url": "https://api.github.com/users/QuincyLarson/orgs",
  "repos_url": "https://api.github.com/users/QuincyLarson/repos",
  "events_url": "https://api.github.com/users/QuincyLarson/events{/privacy}",
  "received_events_url": "https://api.github.com/users/QuincyLarson/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Quincy Larson",
  "company": "@freeCodeCamp ",
  "blog": "https://www.freecodecamp.org",
  "location": null,
  "email": null,
  "hireable": null,
  "bio": "Teacher at https://www.freeCodeCamp.org - Learn to code for free.",
  "twitter_username": null,
  "public_repos": 49,
  "public_gists": 58,
  "followers": 3955,
  "following": 48,
  "created_at": "2011-08-17T04:08:08Z",
  "updated_at": "2021-01-23T20:44:57Z"
  }
